import { TweenMax, TimelineMax, Power4 } from 'gsap/TweenMax';

class YearSlider {
  constructor(ctx) {
    this.ctx = ctx;
    this.yearsItem = Array.from(this.ctx.querySelectorAll('.slider-year__item'));
    this.sliderLimit = this.yearsItem.length - 1;

    this.currentIndex = undefined;
    this.prevIndex = undefined;
    this.nextIndex = undefined;
  }

  setIndex(i) {
    this.currentIndex = i;
    this.prevIndex = i === 0 ? -1 : i - 1;
    this.nextIndex = i === this.sliderLimit ? -1 : i + 1;
  }

  init() {
    this.yearsItem.forEach((item, i) => {
      if (i === this.currentIndex) {
        TweenMax.set(item, { left: '50%' });
        item.classList.add('slider-year__item--initial');
        item.innerHTML = '0000';
      } else if (i === this.prevIndex) {
        TweenMax.set(item, { left: 0, autoAlpha: 0 });
        item.classList.add('slider-year__item--initial-prev');
      } else if (i === this.nextIndex) {
        TweenMax.set(item, { left: '100%', autoAlpha: 0 });
        item.classList.add('slider-year__item--initial-next');
      } else {
        TweenMax.set(item, { left: '150%' });
      }
    });
  }

  animateSlide(prevIndex, currentIndex) {
    const direction = currentIndex > prevIndex ? 'next' : 'prev';
    const currentLeft = direction === 'next' ? '0%' : '100%';
    const prevLeft = direction === 'next' ? '-50%' : '50%';
    const nextLeft = direction === 'next' ? '50%' : '150%';
    const nextIndex = direction === 'next' ? this.nextIndex + 1 : this.prevIndex - 1;
    const nextWord = direction === 'next' ? this.yearsItem[nextIndex] : this.yearsItem[nextIndex];
    const nextWordPrevLeft = direction === 'next' ? '150%' : '-50%';
    const nextWordLeft = direction === 'next' ? '100%' : '0%';
    const tl = new TimelineMax({
      onComplete: () => {
        this.setIndex(currentIndex);
      },
    });

    tl.add('start')
      .to(this.yearsItem[this.currentIndex], 2.3, { left: currentLeft, autoAlpha: 0.2, ease: Power4.easeInOut }, 'start')
      .add(() => {
        this.yearsItem.forEach((el, i) => {
          if (i !== this.currentIndex && i !== this.prevIndex
          && i !== currentIndex && prevIndex + 1 !== i) {
            TweenMax.set(el, { left: i < currentIndex ? '-50%' : '150%' });
          }
        });
      }, 'start');

    if (this.prevIndex !== -1) {
      tl.to(this.yearsItem[this.prevIndex], 2.3, {
        left: prevLeft,
        autoAlpha: direction === 'next' ? 0.2 : 1,
        ease: Power4.easeInOut,
      }, 'start');
    }
    if (this.nextIndex !== -1) {
      tl.to(this.yearsItem[this.nextIndex], 2.3, {
        left: nextLeft,
        autoAlpha: direction === 'next' ? 1 : 0.2,
        ease: Power4.easeInOut,
      }, 'start');
    }
    if (nextWord !== undefined) {
      tl.fromTo(nextWord, 2.3, {
        left: nextWordPrevLeft,
      }, {
        left: nextWordLeft,
        autoAlpha: 0.2,
        ease: Power4.easeInOut,
      }, 'start');
    }

    return tl;
  }
}

export default YearSlider;
